import {Observable} from "rxjs";
import {IDraw} from "../interfaces/draw";

export abstract class LibDrawBaseService {
  abstract validateWinnerByBranchId(branchId: string): Observable<IDraw | null>
}
